import { INavigation } from '../interfaces/INavigation';
import { ILocality } from '../interfaces/ILocality';

export class ParticipationStateModel {
  locality?: ILocality;
  navigation?: INavigation[];
}


